export enum ScoutConnectionStatus {
  Connected = 'connected',
  NotConnected = 'notConnected',
  Processing = 'processing',
}
